import { Vector3 } from 'three';
import Representation3d from './Representation3d';
import Representation3dTypeEnum from './Representation3dTypeEnum';

import apiTriangleMeshSchema from '../../services/bimVisualizerApi/schema/representation3d/apiTriangleMeshSchema';
import { getScaled, getScaledArray } from '../../utils/scaler';

type Normal = { x: number; y: number; z: number };
export default class TriangleMesh extends Representation3d {
    
    vertices: Float32Array = new Float32Array();
    indices: Uint16Array = new Uint16Array;
    normals: Float32Array = new Float32Array();

    constructor(    vertices: Float32Array, 
                    indices: Uint16Array,
                    normals: Float32Array,
                    materialId: number | null) {
        super(Representation3dTypeEnum.TriangleMesh, materialId);
        this.vertices = vertices;
        this.indices = indices;
        this.normals = normals;
    }
    
    // Function to convert to Float32Array
    static convertNormalsToFloat32Array(normals: Normal[][]): Float32Array {
        const flatArray: number[] = [];

        normals.forEach((row) => {
            row.forEach((normal) => {
                flatArray.push(normal.x, normal.y, normal.z);
            });
        });

        return new Float32Array(flatArray);
    }

    clone() : Representation3d {
        return new TriangleMesh(    this.vertices.slice(), 
                                    this.indices.slice(), 
                                    this.normals.slice(), 
                                    this.materialId);
    }

    static fromJSON(json: any): Representation3d {

        const parsed = apiTriangleMeshSchema.parse(json);

        // In the api response, vertices are defined as list of 3d points, so we need to flatten them into 1d array
        var vertices = new Float32Array(parsed.vertices.map((v: any) => getScaledArray([v.x, v.y, v.z])).flat());
        
        // In the api response, indices are grouped by triangle in 2d array, so we need to unpack them first into 1d array
        var indices = new Uint16Array(parsed.indices.flat());

        // In the api response, normals are defined as array of array of three 3d vectors, so we need to flatten them into 1d array
        var normals = this.convertNormalsToFloat32Array(parsed.normals);
        
        return new TriangleMesh( vertices, indices, normals, parsed.materialId);
    }

}